/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */

import * as Msdyn365 from '@msdyn365-commerce/core';
import { getCurrentCategory, CurrentCategoryInput } from '@msdyn365-commerce-modules/retail-actions';
import { CategoryHierarchy } from '@msdyn365-commerce/commerce-entities';

export class GetCategoryByIdInput implements Msdyn365.IActionInput {
    public categoryId: number;
    constructor(categoryId: number) {
        this.categoryId = categoryId;
    }

    public getCacheKey = () => `GETCATEGORYBYID-${this.categoryId}`;
    public getCacheObjectType = () => 'GETCATEGORYBYID';
}

export interface IGetCategoryByIdData {
    currentCategory: CategoryHierarchy;
    categoriesFamily: CategoryHierarchy[] | [];
    parentCategory: CategoryHierarchy;
}

const createInput = (categoryId: number): Msdyn365.IActionInput => {
    return new GetCategoryByIdInput(categoryId);
};

async function action(input: CurrentCategoryInput, ctx: Msdyn365.IActionContext): Promise<IGetCategoryByIdData> {
    const currentCategoryInput = new CurrentCategoryInput(ctx.requestContext, true);
    const currentCategory = await getCurrentCategory(currentCategoryInput, ctx);
    const currentParentCategoryInput = new CurrentCategoryInput(ctx.requestContext, true);
    currentParentCategoryInput.categoryId = currentCategory.ParentCategory;
    const parentCategory = await getCurrentCategory(currentParentCategoryInput, ctx);

    return {
        currentCategory,
        parentCategory,
        categoriesFamily: currentCategory?.Children || parentCategory?.Children || []
    };
}

export default Msdyn365.createObservableDataAction({
    id: 'GETCATEGORYBYID',
    input: args => {
        const categoryId = args.requestContext.query.categoryId ? parseInt(args.requestContext.query.categoryId.toString(), 10) : 0;
        return createInput(categoryId);
    },
    action: <Msdyn365.IAction<IGetCategoryByIdData>>action
});
